    document.addEventListener("DOMContentLoaded", function () {
        const entryText = document.querySelector(".featured-product-entries .entry-tracker #entryText");

        function updateEntryText() {
            // ✅ Always find the checked radio input
            const checkedInput = document.querySelector('.featured-product-entries variant-selects fieldset input[type="radio"]:checked');
            if (checkedInput) {
                const numberValue = checkedInput.value.match(/\d+/)[0]; // Extract number
                entryText.textContent = numberValue;
            }
        }

        // ✅ Recheck every 300ms in case `checked` is added later
        setInterval(updateEntryText, 300);

        // ✅ Also update on manual click
        document.querySelectorAll('.featured-product-entries variant-selects fieldset input[type="radio"]').forEach(input => {
            input.addEventListener("change", updateEntryText);
        });

        // ✅ Initial check on page load
        updateEntryText();
    });

document.addEventListener('DOMContentLoaded', function () {
  const productSpark = document.querySelector('.product-spark');
  const stickySparkForm = document.querySelector('.sticky-spark-form-cls');
  const sparkForm = productSpark?.querySelector('.spark-form-cls'); // Find .spark-form-cls inside .product-spark

  if (productSpark && stickySparkForm && sparkForm) {
    const handleScroll = () => {
      const rect = sparkForm.getBoundingClientRect(); // Get the position of .spark-form-cls

      if (rect.top <= 0) {
        // Add the sticky-form class when .spark-form-cls top reaches the viewport top
        stickySparkForm.classList.add('sticky-form');
      } else {
        // Remove the sticky-form class when scrolling above .spark-form-cls
        stickySparkForm.classList.remove('sticky-form');
      }
    };

    // Listen to the scroll event
    window.addEventListener('scroll', handleScroll);

    // Initial check in case the page loads mid-scroll
    handleScroll();
  }
});



document.addEventListener('DOMContentLoaded', function() {
$('.product-thumbnails__items').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  speed: 500,
  dots: false,
  arrows: true,
  prevArrow: "<button type='button' class='slick-prev pull-left'>❮</button>",
  nextArrow: "<button type='button' class='slick-next pull-right'>❯</button>"
});

// Add functionality to move track on click
$('.product-thumbnails__items').on('click', '.slick-slide', function () {
  const $slick = $('.product-thumbnails__items');
  const index = $(this).data('slick-index');
  const currentSlide = $slick.slick('slickCurrentSlide');

  // Move forward if the second visible slide is clicked
  if (index === currentSlide + 2) {
    $slick.slick('slickNext'); // Move to the next set of slides
  }

  // Move backward if the first visible slide is clicked
  if (index === currentSlide) {
    $slick.slick('slickPrev'); // Move to the previous set of slides
  }
});
});

document.addEventListener('DOMContentLoaded', function() {
  // Get the open and close buttons
  const openButton = document.querySelector('.custom-humburger .open_svg');
  const closeButton = document.querySelector('.custom-humburger .close_svg');

  // Add 'active' class to body when the open button is clicked
  if (openButton) {
    openButton.addEventListener('click', function() {
      document.body.classList.add('active-header');
    });
  }

  // Remove 'active' class from body when the close button is clicked
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      document.body.classList.remove('active-header');
    });
  }
});
